module.exports = __webpack_public_path__ + "img/apply_success.V0.1.0_202607150932.png";